import { UserService } from './service/UserService';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material';
import {Router} from '@angular/router';
import {NgxPermissionsService} from 'ngx-permissions';
import {VersionCheckService} from './service/version-check.service';
import { Guide } from './mock/Guide';
import {environment} from '../environments/environment';
import {By, disableDebugTools, enableDebugTools} from '@angular/platform-browser';
import {MY_TOKEN} from './view/o2-tour/o2-tour.component';
import {O2TourService} from './o2-tour';
import {AuthService} from "./auth/services/auth.service";
import {WatchDogService} from './service/WatchDogService';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  data: Array<any> = new Array(1000).fill(0).map((e, i) => {
    return "item :" + i
  });
  @ViewChild('sidenav') public sidenav: MatSidenav;
  @ViewChild('sidenavCalim') public sidenavCalim: MatSidenav;
  @ViewChild('tour') tour: any;
  columnsDisplay = [
    {def: 'select', show: false},
    {def: 'user', show: false},
    {def: 'status', show: true},
    {def: 'start', show: true},
    {def: 'end', show: true},
    {def: 'Motif', show: true},
    {def: 'Comment', show: true}
  ];
  sideDebug = false;
  appVersion = environment.appVersion;
  constructor(private user: UserService, public router: Router,
              private authService: AuthService,
              private checker: VersionCheckService,
              private permissionsService: NgxPermissionsService,
              public route: Router,
              private watchDogService: WatchDogService ) {
                console.log('environment:' + environment.name)
  }

  ngOnInit() {
    this.permissionsService.permissions$.subscribe((perm) => {
      console.log(perm,  disableDebugTools(), new By())
      //if(Object.keys(perm).indexOf('ROLE_DSI_MYSHIFT2_CLIENT') == -1) {
       // this.checkInspectElement();
      //}
    })
    this.checker.initVersionCheck(environment.versionCheckURL);
    if (location.hash.indexOf('?debug') > -1) {
      let deubg = location.hash.substr(location.hash.indexOf('?debug') + 1, location.hash.length)
      deubg = '{"' + deubg.replace(/\=/g, '":"') + '"}';
      // console.log(deubg)
      this.sideDebug = true;
    }
    const user = this.user.getUser();
    if((!localStorage.getItem("DETAILS") || localStorage.getItem("DETAILS") == 'null') && user) {
      this.authService.getDetailsUser(user.userName).then((details) => {
        localStorage.setItem("DETAILS", JSON.stringify(details));
      })
    }

    // init Analytics
    const enableAnalytics = environment.enableAnalytics;
    if(user && enableAnalytics) {
      const details: any = JSON.parse(localStorage.getItem("DETAILS"));
      this.initAnalytics({siteId: '4', user: {...user, profile: details.profile}});
    }
  }

  initAnalytics(config: {siteId: string, user: {firstName: string, lastName: string, userName: string, email: string,
      countryCode: string, profile: string }}) {
    const {user, siteId} = config;
    const {firstName, lastName, userName, email, countryCode, profile} = user;
    var _paq = (window as any)._paq = (window as any)._paq || [];

    var up = "//analytics.intelcia.com/";
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.src = up + 'matomo.js'; s.parentNode.insertBefore(g, s);

    var analyitcs = null;
    var trackAnalyitcs = () => {
      if(analyitcs) {
        analyitcs.setUserId([firstName, lastName, userName].join(' '));
        analyitcs.setCustomUrl(location.hash.slice(1));
        analyitcs.setReferrerUrl(location.origin);
        ['visit', 'page'].forEach((key: string) => {
          analyitcs.setCustomVariable(1, "username", userName, key);
          analyitcs.setCustomVariable(2, "email", email, key);
          analyitcs.setCustomVariable(3, "country", countryCode, key);
          analyitcs.setCustomVariable(4, "profile", profile, key);
        });
        analyitcs.trackPageView();
        analyitcs.enableLinkTracking();
      }
    };

    g.onload = () => {
      analyitcs = (window as any).Matomo.addTracker('https:' + up+'matomo.php', siteId);
      trackAnalyitcs()
    }
    history.pushState = function()
    {
      setTimeout(trackAnalyitcs, 100)
      History.prototype.pushState.apply(history, arguments);
    }
  }

  loading() {
    let permission = null;
    const user = this.user.getUser() || {};
    const key: number = Object.keys(user).length;
    // console.log(2, user.authorities);
    if ( key > 0) { permission = user.authorities.map((i, n) => i.clientId); }
    const myshiftRoles = user.authorities && user.authorities.filter((i, n) => i.clientId == 'myshift2' || i.clientId == 'myshift2-client').map(i => i.authority);
    return (key > 0 && (permission.indexOf('myshift2') > -1 || permission.indexOf('myshift2-client') > -1));
  }
  getGuide() {
    return Guide;
  }

  checkInspectElement() {
    var element: any = new Image;
    var devtoolsOpen = false;
    element.__defineGetter__("id", function() {
      devtoolsOpen = true; // This only executes when devtools is open.
    });
    var t = setInterval(() => {
      devtoolsOpen = false;
      console.log(element);
      if(devtoolsOpen && this.route.url != '/security') {
        this.route.navigateByUrl('/security')
        //location.href = '/#/security'
        //document.querySelector('app-root').innerHTML = 'Error: ' + new Date().getTime();
      }
      console.clear();
      /*        document.getElementById('output').innerHTML += (devtoolsOpen ? "dev tools is open\n" : "dev tools is closed\n");*/
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts